<template>
  <div class="max-w-4xl mx-auto">
    <Head title="Términos y Condiciones" />
    <h1 class="mb-8 text-3xl font-bold">Términos y Condiciones</h1>

    <div class="prose prose-lg max-w-none">
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">1. Aceptación de los Términos</h2>
        <p class="text-gray-600">
          Al acceder y utilizar Realgestión, usted acepta estar sujeto a estos términos y condiciones. Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al servicio.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">2. Uso del Servicio</h2>
        <p class="text-gray-600">
          Realgestión es un sistema de gestión empresarial diseñado para ayudar en la administración de inventario, ventas y operaciones comerciales. El servicio está destinado únicamente para uso comercial legítimo.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">3. Cuentas de Usuario</h2>
        <p class="text-gray-600">
          Al crear una cuenta, usted es responsable de mantener la confidencialidad de su información de inicio de sesión y de todas las actividades que ocurran bajo su cuenta.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">4. Privacidad y Datos</h2>
        <p class="text-gray-600">
          Nos comprometemos a proteger su privacidad y a manejar sus datos de acuerdo con nuestra Política de Privacidad. Al utilizar nuestro servicio, usted acepta nuestras prácticas de recopilación y uso de datos.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">5. Limitaciones de Uso</h2>
        <p class="text-gray-600">
          No está permitido:
        </p>
        <ul class="list-disc pl-6 text-gray-600 mt-2">
          <li>Usar el servicio para actividades ilegales</li>
          <li>Intentar acceder a áreas restringidas del sistema</li>
          <li>Compartir su cuenta con terceros</li>
          <li>Realizar acciones que puedan dañar el sistema</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">6. Modificaciones</h2>
        <p class="text-gray-600">
          Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en el sitio.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">7. Contacto</h2>
        <p class="text-gray-600">
          Si tiene alguna pregunta sobre estos términos, puede contactarnos a través de nuestro Centro de Ayuda o por WhatsApp.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script> 